import { t } from 'i18next';

import { ErrorResponseErrorItemCodeFileVersion } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeFileVersion, string> => ({
  'file_version:not_found': t('fileVersion.notFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Filversionen kunde inte hittas.',
  }),
  'file_version:user_unauthorized': t('fileVersion.userUnauthorized', {
    ns: 'apiErrorCodes',
    defaultValue: 'Du har inte åtkomst till aktuell filversion.',
  }),
  'file_version:sim_already_exists': t('fileVersion.simAlreadyExists', {
    ns: 'apiErrorCodes',
    defaultValue: 'Filversionen har redan bearbetats.',
  }),
  'file_version:sim_unsupported': t('fileVersion.simUnsupported', {
    ns: 'apiErrorCodes',
    defaultValue: 'Filversionen har redan bearbetats.',
  }),
  'file_version:export_type_not_supported': t('fileVersion.exportTypeNotSupported', {
    ns: 'apiErrorCodes',
    defaultValue: 'Filen går inte att exportera till det valda formatet.',
  }),
  'file_version:file_type_mismatch': t('fileVersion.unexpectedFileFormat', {
    ns: 'apiErrorCodes',
    defaultValue: 'Filen har inte det förväntade filformatet.',
  }),
});
